/* eslint-disable no-useless-catch */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiget } from '../../service/api';

export const fetchPolicyNumberData = createAsyncThunk('fetchPolicyNumberData', async () => {
    const userid = sessionStorage.getItem('user_id');
    const userRole = sessionStorage.getItem("userRole");
    try {
        const response = await apiget(`api/policynumber/`);
        return response?.data?.result;
    } catch (error) {
        throw error;
    }
});

const policyNumberSlice = createSlice({
    name: 'policyNumberDetails',
    initialState: {
        data: [],
        isLoading: false,
        error: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPolicyNumberData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchPolicyNumberData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.error = "";
            })
            .addCase(fetchPolicyNumberData.rejected, (state, action) => {
                state.isLoading = false;
                state.data = [];
                state.error = action.error.message;
            });
    },
});

export default policyNumberSlice.reducer;